const useUserRole = () => {
    return parseInt(document.querySelector('meta[name=role]').content);
};

export default useUserRole;
